import React from "react";
import SvgIcon from '@material-ui/core/SvgIcon';

function DownloadIcon(props) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="13.651" height="13.745" viewBox="0 0 13.651 13.745" {...props}>
      <defs>
        <style>
          {`.cls-8{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.75px}`}
        </style>
      </defs>
      <g id="Group_5967" transform="rotate(-90 -47.87 861.234)">
        <g id="Group_5817" transform="rotate(180 406.245 459.321)">
          <path id="Line_457" d="M0 0L6.63 0" class="cls-8" transform="translate(0 2.713)"/>
          <path id="Path_6435" d="M0 0s2.716 2.1 2.716 2.716S0 5.425 0 5.425" class="cls-8" transform="translate(4.732)"/>
        </g>
        <g id="Group_5818" transform="translate(800.494 909.98)">
          <path id="Path_6436" d="M804.219 909.981a21.02 21.02 0 0 0-2.975.2c-.316.044-.606.592-.637 1.212q-.225 4.538 0 9.077c.032.62.322 1.168.637 1.212a22.866 22.866 0 0 0 3.088.2" class="cls-8" transform="translate(-800.494 -909.98)"/>
        </g>
      </g>
    </SvgIcon>
  );
}

export default DownloadIcon;


// WEBPACK FOOTER //
// ./src/components/icons/DownloadIcon.jsx